import React, { useState, useEffect } from 'react'
import './style.css'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { SendRequestAPI } from '../../redux/slices/ManageRequestSlice'
import { toast } from 'react-toastify'
import { base } from '../../constants/base'

const CorProfileCard = () => {

    const dispatch = useDispatch();
    const singleWorker = useSelector(state => state.SearchFilterSlice.singleWorkerResult)
    const loading = useSelector(state => state.ManageRequestSlice.loading)
    const user = useSelector((state) => state?.AuthSlice?.user);
    const token = localStorage.getItem("token")

    const [service_id, setService_id] = useState("")
    const [schedule_id, setSchadule_id] = useState("")


    const handleServiceSendRequest = async (e) => {
        e.preventDefault();

        const reqObjectHere = {
            user_id: singleWorker?.role?.name === "employee" ? singleWorker?.parent_id : singleWorker?.id,
            customer_id: user?.id,
            service_id: service_id,
            schedule_id: schedule_id,
            employee_id: singleWorker?.id,
            status: "Pending"
        }

        const res = await dispatch(SendRequestAPI(reqObjectHere))

        if (res?.payload?.status === 200) {
            setService_id("")
            setSchadule_id("")
            toast.success("Request Send To Worker")
        }
    }


    return (
        <>
            <div className="profile-card-box">
                <div className="container">
                    <div className="row direction-reverse">
                        <div className="col-xl-5 col-lg-5 col-md-12 cor-pe-0">
                            <div className="profile-card-image-section">
                                <div className="profile-image-sec">
                                    <img
                                        src={
                                            singleWorker?.images?.[0]?.path
                                                ? `${base.imageUrl}${singleWorker.images[0].path}`
                                                : ""
                                        }
                                        alt="Worker Profile"
                                    />
                                    {/* <h3><span><i className="fa-solid fa-star"></i> 4.3</span> 122 Reviews</h3> */}
                                </div>

                                <div className="cor-profile-text-box">
                                    <h1>{singleWorker?.name}</h1>
                                    <p>{singleWorker?.services?.map((item) => item.name).join(", ")}</p>
                                    <p className={`${singleWorker?.status === "Active" ? "active-status" : "block-status"}`}>{singleWorker?.status}</p>
                                    {/* <Link to="/">Edit Profile</Link> */}
                                </div>
                            </div>

                            {/* <div className="profile-services-box">
                                <h1>Professional Services</h1>
                                <div className="services-list-custom">
                                    <h4><i className="fas fa-hands-wash"></i> Flooring</h4>
                                </div>
                            </div> */}
                        </div>

                        <div className="col-xl-7 col-lg-7 col-md-12 cor-ps-0">
                            {/* <div className="gallery-images">
                                <img src="/images/carpenter-profile.jpg" alt="" />
                                <div className="half-images">
                                    <img src="/images/carpenter2.jpg" alt="" />
                                    <img src="/images/carpenter3.jpg" alt="" />
                                </div>
                            </div> */}

                            <div className="profile-discription-box">
                                <h1>Profile Discription</h1>
                                <p>{singleWorker?.about}</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="container">
                    <div className="row mt-5">
                        <div className="col-md-12">
                            <h1 className="page-heading-sides">Select Services</h1>
                            <div className="services-box-main">
                                <div className="flooring-tag">
                                    {
                                        singleWorker?.services?.map((service, index) => {
                                            return <label key={index}>
                                                <input type="radio" className='d-none' name="service" value="electrician" />
                                                <div className="day-card">
                                                    <h3>{service?.name}</h3>
                                                    <h4>{service?.price} <p>{service?.currency === 'USD' ? '$' : service?.currency === 'POUND' ? '£' : '₨'}</p></h4>
                                                </div>
                                            </label>
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                <div className="working-day-slots">
                    <div className="container">
                        <form className="row" onSubmit={handleServiceSendRequest}>
                            <div className="col-md-12 mb-4">
                                <h1 className="page-heading-sides">Select Services</h1>
                                <div className="services-box-main">
                                    <div className="flooring-tag">
                                        {
                                            singleWorker?.services?.map((service, index) => {
                                                return <label key={index} onClick={() => setService_id(service?.id)}>
                                                    <input type="radio" className='d-none' name="service" value="electrician" checked={service_id === service?.id} />
                                                    <div className="day-card">
                                                        <h3>{service?.name}</h3>
                                                        <h4>{service?.price} <p>{service?.currency === 'USD' ? '$' : service?.currency === 'POUND' ? '£' : '₨'}</p></h4>
                                                    </div>
                                                </label>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12">
                                <h1 className="page-heading-sides">Working Time Slot</h1>

                                <div className="days-card-box">
                                    {singleWorker?.schedules?.map((schedule, index) => {
                                        return <label key={index} onClick={() => setSchadule_id(schedule?.id)}>
                                            <input type="radio" name="day" value="monday1" checked={schedule_id === schedule?.id} />
                                            <div className="day-card">
                                                <i className="fa-solid fa-calendar-days"></i>
                                                <h3>{schedule?.day}</h3>
                                                <p>{schedule?.start_time}-{schedule?.end_time}</p>
                                            </div>
                                        </label>
                                    })}
                                </div>
                            </div>

                            <div className="col-md-12 mt-5 d-flex justify-content-center">
                                {
                                    !token ? <button type='button' data-bs-toggle="modal"
                                        href="#exampleModalToggle"
                                        role="button" className='web-button-style'>Hire Worker</button> : <button
                                            type="submit"
                                            className="web-button-style"
                                            disabled={loading || !service_id || !schedule_id}
                                        >
                                        {!loading ? (
                                            "Hire Worker"
                                        ) : (
                                            <i
                                                style={{ fontSize: "22px" }}
                                                className="fa-solid fa-spinner fa-spin"
                                            ></i>
                                        )}
                                    </button>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="modal fade" data-bs-backdrop="static" id="exampleModalToggle" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabIndex={-1}>
                <div className="modal-dialog modal-dialog-centered service-add-model">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn-close" id='close-btn-services' data-bs-dismiss="modal" aria-label="Close"><i className="fa-solid fa-xmark"></i></button>
                        </div>

                        <div className="modal-body">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="employee-form-box" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                                            <h2>LogIn Required</h2>
                                            <p className='text-center'>Kindly log in to proceed with sending a request to the worker. Your account is required to ensure a seamless experience.</p>
                                            <div data-bs-dismiss="modal">
                                                <Link className='web-button-style' to='/signin'>Log In</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CorProfileCard